import { Component, booleanAttribute, input } from '@angular/core';

@Component({
  selector: 'knx-page-hero',
  styles: [
    `
      :host::before {
        position: absolute;
        inset: 0;
        z-index: -1;
        content: '';

        /* Dot pattern */
        background-image:
          radial-gradient(var(--border) 1px, transparent 1px),
          radial-gradient(var(--border) 1px, transparent 1px);
        background-size: 16px 16px;

        /* Diagonal fade mask */
        -webkit-mask-image: linear-gradient(
          135deg,
          black 0%,
          transparent 40%,
          transparent 60%,
          black 100%
        );
        mask-image: linear-gradient(135deg, black 0%, transparent 30%, transparent 70%, black 100%);
        -webkit-mask-composite: destination-in;
        mask-composite: intersect;
      }
    `,
  ],
  templateUrl: './page-hero.component.html',
  host: { class: 'relative z-0 block border-b border-border text-foreground bg-background' },
})
export class PageHeroComponent {
  padded = input(true, { alias: 'knxPadded', transform: booleanAttribute });
}
